import * as Types from "../constants/actionTypes";

export const setBanners = (banners) => (dispatch) => {
  dispatch({
    type: Types.FETCH_BANNER,
    payload: { banners },
  });
};
